var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"areas",attrs:{"id":"areas"}},[_c('CtSelect',{attrs:{"value":_vm.area.provinceStr,"options":_vm.provinceList},on:{"input":_vm.provinceChange}}),_vm._v(" "),_c('CtSelect',{attrs:{"value":_vm.area.cityStr,"options":_vm.cityList},on:{"input":_vm.cityChange}}),_vm._v(" "),_c('CtSelect',{attrs:{"value":_vm.area.countStr,"options":_vm.countList},on:{"input":_vm.countChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3c56c6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/area/Areas.vue
// module id = 12
// module chunks = 0